import { Injectable } from "@angular/core";
import {
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  Resolve,
  Router
} from "@angular/router";
import { Observable } from "rxjs";
import { WordpressService } from "../services/wordpress.service";
import { map } from "rxjs/operators";

@Injectable()
export class PageResolveGuard implements Resolve<any> {
  private pages = [
    { id: 11, slug: "home" },
    { id: 144, slug: "press" },
    { id: 164, slug: "journal" },
    { id: 293, slug: "careers" },
    { id: 324, slug: "gift-cards" },
    { id: 405, slug: "accessibility-statement" }
  ];

  constructor(private router: Router, private wp: WordpressService) {}
  resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<any> {
    const { path } = route.url.length > 0 && route.url[route.url.length - 1];
    const slug = route.url.length > 0 ? path : "home";
    let page = this.pages.find(item => item.slug === slug);

    if (!page) {
      page = this.pages[0];

      if (
        path !== "about" &&
        path !== "menu" &&
        path !== "contact" &&
        path !== "events" &&
        path !== "accessibility-statement"
      ) {
        this.router.navigate(["/"]);
      }
    }

    return this.wp.getPage(page.id).pipe(
      map(res => {
        if (
          !res ||
          (Object.keys(res).length === 0 && res.constructor === Object)
        ) {
          // NOT FOUND
          if (path !== "about" && path !== "menu" && path !== "contact") {
            this.router.navigate(["/"]);
            return null;
          }
        }

        return res.acf;
      })
    );
  }
}
